module.exports = __webpack_public_path__ + "assets/tessa-grey.svg";